import React from 'react';
import { useTheme } from '../../../hooks/useTheme';
import './EventsList.css';

/**
 * Component for displaying the list of recorded events with numbered circles integrated into cards
 */
const EventsList = ({
  events,
  homeTeamName,
  awayTeamName,
  editEvent,
  deleteEvent,
  handleUndoLastEvent,
  showToast
}) => {
  // Access theme for conditional styling
  const { theme } = useTheme();

  // Function to handle event editing
  const handleEditEvent = (eventId) => {
    if (editEvent) {
      editEvent(eventId);
    } else {
      alert('Edit functionality not yet implemented in parent component');
    }
  };

  // Function to handle event deletion
  const handleDeleteEvent = (eventId) => {
    if (deleteEvent) {
      // Ask for confirmation before deleting
      if (window.confirm('Are you sure you want to delete this event?')) {        
          deleteEvent(eventId);
      }
    }
  };

  return (
    <div className={`control-panel recorded-events-panel ${theme === 'high-contrast' ? 'high-contrast' : ''}`}>
      <div className="panel-title-container">
        <h3 className="panel-title">Recorded Events</h3>
        <button 
          className="undo-button" 
          onClick={handleUndoLastEvent}
          disabled={events.length === 0}
          title="Undo last event"
        >
          ⎌
        </button>
      </div>
      <div className="events-list">
        {events.length === 0 ? (
          <div className="no-events-message">
            <p>No events recorded yet.</p>
            <p>Click on the field to record an event.</p>
          </div>
        ) : (
          [...events].reverse().map((event, index) => (
            <div key={event.id} className={`event-item ${event.team.toLowerCase()}`}>
              <div className="event-details">
                {/* Integrated number circle */}
                <div 
                  className={`event-number ${event.team.toLowerCase()}-number`}
                >
                  {events.length - index}
                </div>
                
                <div className="event-time-type">
                  <span className="event-time">{event.timestamp}</span>
                  <span className="event-type">{event.eventType}</span>
                </div>
                <div className="event-team-actions">
                  <div className="event-team-player">
                    <span className={`event-team ${event.team.toLowerCase()}`}>
                      {event.team === 'Home' ? homeTeamName : awayTeamName}
                    </span>
                  </div>
                  <div className="event-actions">
                    <button className="event-action-btn edit" onClick={() => handleEditEvent(event.id)} title="Edit">
                      <span className="action-icon">✎</span>
                    </button>
                    <button className="event-action-btn delete" onClick={() => handleDeleteEvent(event.id)} title="Delete">
                      <span className="action-icon">✖</span>
                    </button>
                  </div>
                </div>
                {event.comment && (
                  <div className="event-comment">{event.comment}</div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default EventsList;